import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Modal, Row, Table } from 'antd';
import { useFormik } from 'formik';
import moment from 'moment';
import React from 'react';
import * as yup from 'yup';
import { hotel_columns } from './TripTables';

const hotelValidation = yup.object().shape({
  hotel_reservations: yup.array().of(yup.object().shape({
    duration_from: yup.string().required("Check In is required"),
    duration_to: yup.string().required("Check Out is required"),
    location: yup.string().required("City is required"),
    description: yup.string().required("Description from is required")
  }))
})
const HotelForm = ({ tripForm, isEdit, isModalVisible, setIsModalVisible }) => {
  const { hotel_reservations = [] } = tripForm?.values;
  const hotelFormik = useFormik({
    initialValues: {
      hotel_reservations: [{
        duration_from: "",
        duration_to: "",
        location: "",
        description: ""
      }],
    },
    validationSchema: hotelValidation,
    onSubmit: (vals) => {
      tripForm.setFieldValue("hotel_reservations", [...vals.hotel_reservations])
      handleModalCancelButton()
    }
  })

  const handleModalCancelButton = () => {
    setIsModalVisible(false)
    hotelFormik.resetForm()
  }

  const onNewRowChange = (type, idx) => {
    if (type === "remove") {
      if (idx > -1) {
        let trips = hotelFormik.values.hotel_reservations
        trips.splice(idx, 1)
        hotelFormik.setFieldValue("hotel_reservations", trips)
      }
    } else {
      let hr = hotelFormik.values.hotel_reservations;
      hr = [...hr, {
        duration_from: "",
        duration_to: "",
        location: "",
        description: ""
      }]
      hotelFormik.setFieldValue("hotel_reservations", hr)
    }
  }


  React.useEffect(() => {
    if (isModalVisible)
      hotelFormik.setFieldValue(
        'hotel_reservations', hotel_reservations?.length === 0 ? [{
          duration_from: "",
          duration_to: "",
          location: "",
          description: ""
        }] : hotel_reservations
      )
    // eslint-disable-next-line
  }, [isModalVisible])

  const renderHotelForm = () => <form
    onSubmit={hotelFormik.handleSubmit}
    className="modal-form"
  >
    <div className="trips-detail detail-card p1">
      {hotelFormik.values?.hotel_reservations?.map((item, index) => (
        <Row className='mt1' key={`hotelrows_${index}`}>
          <Col span={5}>
            <Form.Item label={<>Visiting City<span className="required-star">*</span></>}
            >
              <Input placeholder="Enter"
                value={hotelFormik.values?.hotel_reservations[index]?.location}
                onChange={(e) => {
                  let fr = [...hotelFormik.values?.hotel_reservations];
                  fr[index].location = e.target.value;
                  hotelFormik.setFieldValue("hotel_reservations", fr);
                }}
              />
              {hotelFormik.touched.hotel_reservations?.[index]?.location && hotelFormik.errors.hotel_reservations?.[index]?.location && <div className='errorMsg'>
                {hotelFormik.errors.hotel_reservations?.[index]?.location}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5} className="ml1">
            <Form.Item label={<>Check In<span className="required-star">*</span></>}>
              <DatePicker format={'DD/MM/YYYY HH:mm:ss a'} showTime
                value={
                  hotelFormik.values?.hotel_reservations[index]?.duration_from ?
                    moment(hotelFormik.values?.hotel_reservations[index]?.duration_from, 'DD/MM/YYYY HH:mm:ss a') :
                    undefined}
                onChange={(date) => {
                  let fr = [...hotelFormik.values?.hotel_reservations];
                  fr[index].duration_from = date ? moment(date).format('DD/MM/YYYY HH:mm:ss a') : ""
                  fr[index].duration_to = ""
                  hotelFormik.setFieldValue("hotel_reservations", fr)
                }}
              />
              {hotelFormik.touched.hotel_reservations?.[index]?.duration_from && hotelFormik.errors.hotel_reservations?.[index]?.duration_from && <div className='errorMsg'>
                {hotelFormik.errors.hotel_reservations?.[index]?.duration_from}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5} className="ml1">
            <Form.Item label={<>Check out<span className="required-star">*</span></>}
            >
              <DatePicker format={'DD/MM/YYYY HH:mm:ss a'} showTime
               showNow={ 
                  !moment(hotelFormik.values?.hotel_reservations[index]?.duration_from, "DD/MM/YYYY HH:mm:ss a")
                  .isAfter(moment()) 
                }
                value={
                  hotelFormik.values?.hotel_reservations[index]?.duration_to ?
                    moment(hotelFormik.values?.hotel_reservations[index]?.duration_to, 'DD/MM/YYYY HH:mm:ss a') :
                    undefined}
                onChange={(date) => {
                  let fr = [...hotelFormik.values?.hotel_reservations];
                  fr[index].duration_to = date ? moment(date).format('DD/MM/YYYY HH:mm:ss a') : ""
                  hotelFormik.setFieldValue("hotel_reservations", fr)
                }}
                disabledDate={(current) => {
                  let customDate = moment(hotelFormik.values?.hotel_reservations[index]?.duration_from, "DD/MM/YYYY HH:mm:ss a");
                  return current && current < moment(customDate);
                }}
              />
              {hotelFormik.touched.hotel_reservations?.[index]?.duration_to && hotelFormik.errors.hotel_reservations?.[index]?.duration_to && <div className='errorMsg'>
                {hotelFormik.errors.hotel_reservations?.[index]?.duration_to}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5} className="ml1">
            <Form.Item label={<>Description<span className="required-star">*</span></>}>
              <Input.TextArea
                placeholder="Enter Description"
                autoSize={{ minRows: 1, maxRows: 5 }}
                maxLength={250}
                value={hotelFormik.values?.hotel_reservations?.[index]?.description}
                onChange={(e) => {
                  let fr = [...hotelFormik.values?.hotel_reservations];
                  fr[index].description = e.target.value
                  hotelFormik.setFieldValue("hotel_reservations", fr)
                }}
              />
              {hotelFormik.touched.hotel_reservations?.[index]?.description && hotelFormik.errors.hotel_reservations?.[index]?.description && <div className='errorMsg'>
                {hotelFormik.errors.hotel_reservations?.[index]?.description}
              </div>}
            </Form.Item>
          </Col>
          <Col span={1}>
            {index >= 1 ?
              <MinusCircleOutlined className='mt3' onClick={() => onNewRowChange('remove', index)} /> : null}
          </Col>
        </Row>
      ))}
      {hotel_reservations.length <= 5 ? <>
        <hr />
        <div className='p1 cursor' onClick={() => onNewRowChange('add')}> + Add another line</div>
      </> : null
      }
    </div>

    <div className='mb3 mt1'>
      <Button key="2" className="cancelButton ml1 mt3 floatRight" onClick={() => handleModalCancelButton()}>Cancel</Button>
      <Button key="1" htmlType="submit" className="formButton mt3 primaryButton floatRight"
      >Save</Button>
    </div>
  </form>
  return (
    <>
      <Modal
        title={"Add Hotel Details"}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
        }}
        footer={[]}
        className="center-aligned-modal-big"
      >
        {renderHotelForm()}
      </Modal>
      <div className="trips-detail detail-card mb2">
        <div className='mt1'>
          <Button
            className="primary-btn floatRight mr1"
            onClick={() => {
              setIsModalVisible(true);
            }}
          >
            {hotel_reservations?.length ? 'Edit' : `Add Hotel Details`}
          </Button>
        </div>
        <Table
          rowKey="id"
          columns={hotel_columns}
          dataSource={hotel_reservations?.length ? hotel_reservations : []}
          className="settingsTable tripsTable"
          pagination={false}
        />
      </div>
    </>
  )
};

export default HotelForm;